import locale from "@bonliva-crm/locale";

export const OptionYesNoValues = {
  null: "null",
  true: "true",
  false: "false"
} as const;

export type OptionYesNoValues = keyof typeof OptionYesNoValues;

export const optionYesNo = [
  {
    label: locale.Yes,
    value: "true" as const
  },
  {
    label: locale.No,
    value: "false" as const
  }
];
